import React, { ReactElement } from 'react'
import { RegistrationLayoutHeader } from './components/RegistrationLayoutHeader/RegistrationLayoutHeader'
import { RegistrationLayoutFooter } from './components/RegistrationLayoutFooter/RegistrationLayoutFooter'
import style from './RegistrationLayout.module.css'

interface IRegistrationLayoutProps {
  children: ReactElement
  withIsLoginRedirect?: boolean
  hasBackArrow?: boolean
  withProfile?: boolean
  withLocalizationButton?: boolean
}

export const RegistrationLayout: React.FC<IRegistrationLayoutProps> = ({
  withLocalizationButton,
  withIsLoginRedirect,
  hasBackArrow,
  withProfile,
  children,
}) => (
  <div className={style.container}>
    <RegistrationLayoutHeader
      hasBackArrow={hasBackArrow}
      withProfile={withProfile}
      withLocalizationButton={withLocalizationButton}
      withIsLoginRedirect={withIsLoginRedirect}
    />
    {children}
    <RegistrationLayoutFooter />
  </div>
)

RegistrationLayout.displayName = 'RegistrationLayout'
